import axiosInstance from './axios';

const API_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:9000';

console.log('API URL:', API_URL); // Add this for debugging

export const noteService = {
  // Folder operations
  getFolders: () => axiosInstance.get(`/api/folders`),
  createFolder: (folderData) => axiosInstance.post(`/api/folders`, folderData),
  updateFolder: (id, folderData) => axiosInstance.put(`/api/folders/${id}`, folderData),
  deleteFolder: (id) => axiosInstance.delete(`/api/folders/${id}`),

  // Note operations
  getNotes: (folderId) => axiosInstance.get(`/api/folders/${folderId}/notes`),
  getNote: (folderId, noteId) => axiosInstance.get(`/api/folders/${folderId}/notes/${noteId}`),
  createNote: (folderId, noteData) => axiosInstance.post(`/api/folders/${folderId}/notes`, noteData),
  updateNote: (folderId, noteId, noteData) => axiosInstance.put(`/api/folders/${folderId}/notes/${noteId}`, noteData),
  deleteNote: (folderId, noteId) => axiosInstance.delete(`/api/folders/${folderId}/notes/${noteId}`),

  getFolderById: (folderId) => axiosInstance.get(`/api/folders/${folderId}/notes`),
  getNotesByFolder: (folderId) => axiosInstance.get(`/api/folders/${folderId}/notes`)
};
